import React from 'react';
import { Card, CardBody, Col, CustomInput, Row } from 'reactstrap';
import IconButton from '~/components/IconButton';
import history from '~/services/history';

export default function CustomerProfileCard({
  customer,
  isSelected,
  onSelect,
  onDelete,
  isAllowedToBatch,
}) {
  return (
    <Card className="card new-layout list-card grow-on-hover">
      <CardBody className="card-body new-layout px-3 py-3">
        <Row className="w-100 h-100 mx-0 d-none d-md-flex">
          <Col xs={1} align="center" className="h-100">
            {isAllowedToBatch && (
              <div
                className="h-100 d-flex flex-row justify-content-center align-items-center flex-wrap d-none outline-none"
                onClick={e => {
                  e.stopPropagation();
                }}
                role="button"
                tabIndex={0}
                aria-label="checkbox-wrapper-div"
              >
                <CustomInput
                  type="checkbox"
                  id={`${customer.id}-checkbox`}
                  className="text-primary"
                  checked={isSelected}
                  defaultValue={isSelected}
                  onChange={() => onSelect(customer, isSelected)}
                />
              </div>
            )}
          </Col>
          <Col
            xs={2}
            align="start"
            className="h-100 d-flex flex-column justify-content-center"
          >
            {customer.broken_name.map((word, index) => {
              return (
                <div
                  key={`${word}-${customer.id}`}
                  className={`new-layout-card-list-strong-value w-100 ${
                    index > 0 && 'text-truncate'
                  }`}
                >
                  {word}
                </div>
              );
            })}
          </Col>
          <Col
            xs={3}
            align="start"
            className="h-100 d-flex flex-column justify-content-center"
          >
            {customer.email ? (
              <>
                {customer.broken_email.map((word, index) => {
                  return (
                    <div
                      key={`${word}-${customer.id}`}
                      className={`new-layout-table-column-value ${
                        index > 0 && 'text-truncate'
                      }`}
                    >
                      {`${index === 1 ? '@' : ''}${word}`}
                    </div>
                  );
                })}
              </>
            ) : (
              <div className="new-layout-table-column-value h-100 text-truncate">
                Não informado
              </div>
            )}
          </Col>
          <Col xs={3} align="center" className="h-100">
            <div className="new-layout-table-column-value h-100 text-truncate">
              {customer.telephone || 'Não informado'}
            </div>
          </Col>
          <Col xs={2} align="start" className="h-100 d-flex flex-row flex-wrap">
            <div className="new-layout-table-column-value h-100 text-truncate">
              {customer.birth_date || 'Não informado'}
            </div>
          </Col>
          <Col xs={1} align="center" className="h-100">
            <div className="h-100 d-flex flex-row align-items-center justify-content-around">
              <IconButton
                icon="las la-search"
                color="info"
                id={`details-btn-${customer.id}`}
                tip="Detalhes"
                forceTip
                click={() => {
                  history.push(`/clientes/perfil/${customer.id}`);
                }}
              />

              <IconButton
                icon="las la-pen"
                color="primary"
                id={`edit-btn-${customer.id}`}
                tip="Editar"
                forceTip
                click={() => {
                  history.push(`/clientes/perfil/${customer.id}/editar`);
                }}
              />
              <IconButton
                icon="las la-trash"
                color="danger"
                id={`delete-btn-${customer.id}`}
                tip="Excluir"
                forceTip
                click={() => onDelete(customer)}
              />
            </div>
          </Col>
        </Row>
        <Row className="w-100 h-100 mx-0 d-md-none">
          <Col className="px-0">
            <Row className="w-100 mx-0">
              <Col xs={9} align="start" className="px-0">
                <Row className="w-100 mx-0">
                  <div className="d-flex flex-row align-items-baseline w-100">
                    <div className="new-layout-card-mobile label d-inline">
                      Cliente:
                    </div>
                    <div
                      className="new-layout-card-list-strong-value ml-1 d-inline text-truncate"
                      style={{ maxWidth: '75%' }}
                    >
                      {customer.name}
                    </div>
                  </div>
                </Row>
              </Col>
              <Col xs={3} className="px-0" align="end">
                <div className="h-100 d-flex flex-row justify-content-around">
                  <IconButton
                    icon="las la-search"
                    color="info"
                    id={`details-mobile-btn-${customer.id}`}
                    tip="Detalhes"
                    click={() => {
                      history.push(`/clientes/perfil/${customer.id}`);
                    }}
                  />

                  <IconButton
                    icon="las la-pen"
                    color="primary"
                    id={`edit-mobile-btn-${customer.id}`}
                    tip="Editar"
                    click={() => {
                      history.push(`/clientes/perfil/${customer.id}/editar`);
                    }}
                  />
                  <IconButton
                    icon="las la-trash"
                    color="danger"
                    id={`delete-mobile-btn-${customer.id}`}
                    tip="Excluir"
                    click={() => onDelete(customer)}
                  />
                </div>
              </Col>
            </Row>
            <Row className="w-100 mx-0">
              <Col className="px-0">
                <div className="d-flex flex-row align-items-baseline">
                  <div className="new-layout-card-mobile label d-inline">
                    E-mail:
                  </div>
                  <div className="new-layout-card-mobile value d-inline text-truncate">
                    {customer.email || 'Não informado'}
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="w-100 mx-0">
              <Col className="px-0">
                <div className="d-flex flex-row align-items-baseline">
                  <div className="new-layout-card-mobile label d-inline">
                    Telefone:
                  </div>
                  <div className="new-layout-card-mobile value d-inline">
                    {customer.telephone || 'Não informado'}
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="w-100 mx-0">
              <Col className="px-0">
                <div className="d-flex flex-row align-items-baseline">
                  <div className="new-layout-card-mobile label d-inline">
                    Nascimento:
                  </div>
                  <div className="new-layout-card-mobile value d-inline">
                    {customer.birth_date || 'Não informado'}
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
